import React, {useRef, useEffect, useState} from "react";
import mapboxgl from "mapbox-gl";
import MapboxGeocoding from '@mapbox/mapbox-sdk/services/geocoding';
import 'mapbox-gl/dist/mapbox-gl.css';
import {Box, Input} from "@chakra-ui/react";

mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_TOKEN;

export default function MapboxMoveable({address, coordinates, onCoordinatesChange}) {

    const mapContainerRef = useRef(null);
    const [zoom, setZoom] = useState(9);
    const markerRef = useRef(null); // Reference to the marker

    useEffect(() => {
        const mapInstance = new mapboxgl.Map({
            container: mapContainerRef.current,
            style: "mapbox://styles/mapbox/streets-v11",
            // center: [coordinates.lng, coordinates.lat],
            zoom: zoom,
        });

        mapInstance.on('move', () => {
            setZoom(mapInstance.getZoom().toFixed(2));
        });

        // Call geocoding function after map is initialized
        if(coordinates){
            setMarker(mapInstance, coordinates)
        } else {
            handleGeocode(mapInstance);
        }

        return () => mapInstance.remove();
    }, [address]);

    const setMarker = (mapInstance, coordinates) => {
        // Fly to the new location
        mapInstance.jumpTo({
            center: coordinates,
            zoom: 14
        });

        // If a marker already exists, remove it
        if (markerRef.current) {
            markerRef.current.remove();
        }

        // Add a draggable marker
        const marker = new mapboxgl.Marker({draggable: true})
            .setLngLat(coordinates)
            .addTo(mapInstance);

        markerRef.current = marker;

        // Listen for dragend event to capture new coordinates
        marker.on("dragend", () => {
            if (onCoordinatesChange) {
                onCoordinatesChange(marker.getLngLat());
            }
        });

        onCoordinatesChange(marker.getLngLat());
    }
    const handleGeocode = (mapInstance) => {
        const geocodingClient = MapboxGeocoding({accessToken: mapboxgl.accessToken});

        geocodingClient.forwardGeocode({
            query: address,
            limit: 1
        })
            .send()
            .then(response => {
                const match = response.body.features[0];
                const coordinates = match.geometry.coordinates;
                setMarker(mapInstance, coordinates)
            })
            .catch(error => {
                console.error("Error fetching geocode data: ", error);
            });
    };

    return (
        <div>
            <Input
                value={address ? address : ''}
                isDisabled={true}
            />
            <Box mt={5}>
                <div ref={mapContainerRef} style={{width: '100%', height: '500px'}}/>
            </Box>
        </div>
    )
        ;
}
